import { gql } from '@apollo/client'
import ConfirmPhotoModal from 'components/Dashboard/ConfirmPhotoModal'
import RawJsonDisplay from 'components/Dashboard/RawJsonDisplay'
import { useState } from 'react'
import { LabEventEventFragment } from './__generated__/LabEventEventFragment'

export const labEventEventFragment = gql`
  fragment LabEventEventFragment on LabEventEvent {
    asJson
    labEvent {
      id
      photo {
        id
      }
    }
  }
`

const LabEventEvent = ({ event }: { event: LabEventEventFragment }) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <div>
      {event.labEvent.photo && (
        <button className="button is-small" onClick={() => setShowModal(true)}>
          View Photo
        </button>
      )}

      <RawJsonDisplay json={event.asJson} />

      {showModal && (
        <ConfirmPhotoModal
          result={{ id: event.labEvent.id }}
          readOnly
          kitId="KitID"
          sku="SKU"
          onClose={() => setShowModal(false)}
        />
      )}
    </div>
  )
}

export default LabEventEvent
